import { EntityLang } from '/@/modules/core/app/services/EntityLang';
import { getters } from '/@/modules/core/app/helpers/store';
import { PredefinedCountry } from '/@/modules/predefined/enums/PredefinedCountry';
import { PredefinedJurisdiction } from '/@/modules/predefined/enums/PredefinedJurisdiction';

export class EstateJurisdictionLang extends EntityLang {
  /**
   * @returns {?CurrentEstate}
   */
  get estate() {
    return getters.auth.getCurrentEstate();
  }

  /**
   * @returns {Jurisdiction}
   */
  get estateJurisdiction() {
    return this.estate?.jurisdiction;
  }

  /**
   * @returns {string}
   */
  get contactSocialSecurityOrInsurance() {
    switch (this.estateJurisdiction?.countryId) {
      case PredefinedCountry.UNITED_STATES.id:
        return this.t('Social Security Number (SSN)');
      case PredefinedCountry.CANADA.id:
      default:
        return this.t('Social Insurance Number (SIN)');
    }
  }

  /**
   * @returns {string}
   */
  get lawyerLabel() {
    switch (this.estateJurisdiction?.id) {
      case PredefinedJurisdiction.QUEBEC.id:
        return this.t('notary');
      default:
        return this.t('lawyer');
    }
  }

  /**
   * @returns {string}
   */
  get guardianLabel() {
    switch (this.estateJurisdiction?.id) {
      case PredefinedJurisdiction.QUEBEC.id:
        return this.t('tutor');
      default:
        return this.t('guardian');
    }
  }

  /**
   * @returns {string}
   */
  get alternateGuardianLabel() {
    switch (this.estateJurisdiction.id) {
      case PredefinedJurisdiction.QUEBEC.id:
        return this.t('user.alternate-tutor');
      default:
        return this.t('user.alternate-guardian');
    }
  }

  /**
   * @returns {string}
   */
  get guardiansLabel() {
    switch (this.estateJurisdiction?.id) {
      case PredefinedJurisdiction.QUEBEC.id:
        return this.t('tutors');
      default:
        return this.t('guardians');
    }
  }

  /**
   * @returns {string}
   */
  get guardianshipLabel() {
    switch (this.estateJurisdiction?.id) {
      case PredefinedJurisdiction.QUEBEC.id:
        return this.t('tutorship');
      default:
        return this.t('guardianship');
    }
  }

  /**
   * @returns {string}
   */
  get powerOfAttorneyLabel() {
    switch (this.estateJurisdiction?.id) {
      case PredefinedJurisdiction.QUEBEC.id:
        return this.t('Protection Mandate');
      default:
        return this.t('Power of Attorney');
    }
  }

  /**
   * @returns {string}
   */
  get executor() {
    switch (this.estateJurisdiction?.id) {
      case PredefinedJurisdiction.QUEBEC.id:
        return this.t('liquidator');
      default:
        return this.t('executor');
    }
  }

  /**
   * @returns {string}
   */
  get executorship() {
    switch (this.estateJurisdiction?.id) {
      case PredefinedJurisdiction.QUEBEC.id:
        return this.t('liquidatorship');
      default:
        return this.t('executorship');
    }
  }

  /**
   * @returns {string}
   */
  get insuranceNumberLabel() {
    switch (this.estateJurisdiction?.id) {
      case PredefinedJurisdiction.QUEBEC.id:
        return this.t('Health Insurance Number');
      default:
        return this.t('Personal Insurance Number');
    }
  }

  /**
   * @returns {string}
   */
  get guidanceMeetingInstructionsUrl() {
    switch (this.estateJurisdiction?.id) {
      case PredefinedJurisdiction.QUEBEC.id:
        return this.t(
          'https://8693223.fs1.hubspotusercontent-na1.net/hubfs/8693223/Platform%20meeting%20instructions/QC%20ClearVault%20-%20Will%20Preparation%20meeting%20-%20Required%20Information%20and%20documents%20.pdf'
        );
      default:
        return this.t(
          'https://f.hubspotusercontent20.net/hubfs/8693223/ClearVault%20-%20Will%20Preparation%20meeting%20-%20Required%20Information%20and%20documents%20.pdf'
        );
    }
  }
}

export default new EstateJurisdictionLang();
